import React, { Component } from 'react';
import PageLoader from '../Layouts/PageLoader';
import AuthApi from '../Services/Authapi';

class InitComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
        this.getAuth();
    }

    async getAuth() {
        try {
            let checkLogin = await AuthApi.checkAuth();
            if (checkLogin && checkLogin.status !== false) {
                this.props.setAutUser({ authUser: checkLogin.user, authuserAccessser1: checkLogin.userAccess });
                // Redirect to dashboard if authenticated
                this.props.history.push('/dashboard');
            } else {
                this.props.setAutUser({ authUser: false, authToken: false });
                // Redirect to login if not authenticated
                this.props.history.push('/login');
            }
        } catch (error) {
            console.error('Auth check failed:', error);
            this.props.setAutUser({ authUser: false, authToken: false });
            // Redirect to login on error
            this.props.history.push('/login');
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() { 
        return <PageLoader />;
    }
}
export default InitComponent;